import React from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider, App as AntApp } from "antd";
import zhCN from "antd/locale/zh_CN";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import "@dreamverse/design-tokens/css";
import "antd/dist/reset.css";
import "./index.css";
import { AuthProvider } from "./services/auth";
import { CharacterProvider } from "./services/character";
import { AppRoutes } from "./App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 管理端的数据是排障用的，宁可多请求一次也不要看过期数字。
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// 品牌色取自 packages/design-tokens。
// 主要实心按钮用 #AD4A57（brand-600）+ 白字，满足普通文本对比度；
// #CF747F 只用于选中态与图表，不做整页粉色。
const theme = {
  token: {
    colorPrimary: "#AD4A57",
    colorLink: "#8F3846",
    colorError: "#B4232E",
    colorSuccess: "#2F7A4B",
    colorWarning: "#9A6413",
    colorInfo: "#286E85",
    borderRadius: 6,
    fontSize: 13,
  },
  components: {
    Menu: { itemSelectedBg: "#F8E4E7", itemSelectedColor: "#8F3846" },
    Layout: { bodyBg: "#FFF9F8", siderBg: "#FFFFFF", headerBg: "#FFFFFF" },
  },
};

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN} theme={theme}>
      <AntApp>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <CharacterProvider>
                <AppRoutes />
              </CharacterProvider>
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </AntApp>
    </ConfigProvider>
  </React.StrictMode>,
);
